import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./map.scss";

// чиним пути к PNG-иконкам leaflet
import marker2x from "leaflet/dist/images/marker-icon-2x.png";
import marker from "leaflet/dist/images/marker-icon.png";
import shadow from "leaflet/dist/images/marker-shadow.png";
L.Icon.Default.mergeOptions({ iconRetinaUrl: marker2x, iconUrl: marker, shadowUrl: shadow });

// твои точки (можно расширять список)
const POINTS = [
  {
    id: "fun-gym",
    lat: 56.93122004644575,
    lng: 24.204969929275077,
    title: 'Sporta zāle "Fun Gym"',
    lines: [
      "Aktiva atputa, Kikbokss, Point-fight, Bokss, Taekvondo un Fitness",
    ],
  },
  {
    id: "Tīģerēns",
    lat: 56.947459063516035,
    lng: 23.993412195505222,
    title: "Tīģerēns",
    lines: ["Point Fight un Taekvondo nodarbības bērniem",
      "Vispusiga attīstība"
    ],
  },
  {
    id: "Tīģerēns",
    lat: 56.95503152382442,
    lng: 24.03998462681142,
    title: "Tīģerēns",
    lines: ["Point Fight un Taekvondo nodarbības bērniem",
      "Vispusiga attīstība"
    ],
  },
];

export default function Map() {
  // границы, чтобы карта автоматически влезала по всем маркерам
  const bounds = useMemo(
    () => L.latLngBounds(POINTS.map(p => [p.lat, p.lng])),
    []
  );

  return (
    <div id="map" className="map-container map-conteiner">
      <MapContainer
        className="map-size"
        bounds={bounds}
        boundsOptions={{ padding: [40, 40], maxZoom: 15 }}
        scrollWheelZoom
        tap={false}            // фикс тач-багов на iOS/Safari
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {POINTS.map(p => (
          <Marker key={p.id} position={[p.lat, p.lng]}>
            <Popup>
              <strong>{p.title}</strong>
              <br />
              {p.lines?.map((l, i) => (
                <span key={i}>
                  {l}
                  <br />
                </span>
              ))}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
